import { Button, Modal, Row, Space } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { BiRefresh, BiUpload } from 'react-icons/bi';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { ICommonState, IManifestFileUploads } from '../../../../../model/CommonModel';
import { useCommonStore } from '../../../../../stores/CommonStore';
import { useOperationStore } from '../../../../../stores/OperationStore';
import { emptyUploadedFileValue } from '../../../../../stores/common';
import { CountryEnum, Employee, UserEnum, fileToBase64, isAccessible, isProdMode } from '../../../../../utils/app-common';
import LoadingModalComponent from '../../../../CommonComponent/LoadingModalComponent';
import { useManifestContextHook } from './Context/useManifestContextHook';
import ImageRenderComponent from './ImageRenderComponent';

type Props = {
    open: boolean,
    onClose: (value: boolean) => void,
}


const FileComponent = ({ open, onClose }: Props) => {
    const { waybillNo } = useManifestContextHook();

    const { promiseInProgress: fileUploadProgress } = usePromiseTracker(({ area: 'file-upload-area' }));

    const UploadManifestFileAction = useCommonStore((state) => state.UploadManifestFileAction);

    const onChange = useCallback((event: any) => {
        const [files] = (event.target as HTMLInputElement).files ?? [];
        const reader = fileToBase64(files)
        reader.onload = () => {
            const request: IManifestFileUploads = {
                attachmentList: [{
                    waybillNo: waybillNo,
                    attachmentDataString: (reader.result?.toString())?.split(',')[1] ?? '',
                    fileType: files?.type?.split('/')?.at(1)
                }]
            };
            trackPromise(UploadManifestFileAction(request, waybillNo), 'file-upload-area')
        };
        reader.onerror = error => {
            console.error("Error: ", error);
        };

    }, [UploadManifestFileAction, waybillNo]);


    return (
        <Modal maskClosable={false} open={open} width={500} onOk={() => onClose(false)} onCancel={() => onClose(false)} title='Manifest File Upload'>
            <LoadingModalComponent isLoading={fileUploadProgress}>
                <Row>
                    <input className='upload'
                        type='file'
                        onChange={onChange}
                        onClick={emptyUploadedFileValue}
                        placeholder='UploadFile' />
                </Row>
            </LoadingModalComponent>
        </Modal>
    )
}

const FileUploadComponent = () => {
    const manifestFiles = useCommonStore(state => state.manifestFiles);
    const GetManifestFilesListAction = useCommonStore((state: ICommonState) => state?.GetManifestFilesListAction);

    const { waybillNo } = useManifestContextHook();

    const { promiseInProgress: fileListPromise } = usePromiseTracker(({ area: 'manifest-file-area' }));
    const { isOracleInvoiced, sentForOracleInvoicing } = useManifestContextHook();
    const getFiles = useCallback(() => {
        useCommonStore.setState({ manifestFiles: [] })
        trackPromise(GetManifestFilesListAction(waybillNo), 'manifest-file-area');
    }, [GetManifestFilesListAction, waybillNo])
    const hasManifestationBtnAccess = isProdMode() ? isAccessible([Employee.IMATHUL_RAFI], [CountryEnum.UAE], true) : false;

    useEffect(() => {
        getFiles()
    }, [getFiles])


    const [isOpen, setIsOpen] = useState(false);
    const fileUploadResponse = useCommonStore((state) => state.fileUploadResponse);

    useEffect(() => {
        setIsOpen(false)
        useOperationStore.setState({ fileUploadResponse: undefined })
    }, [fileUploadResponse])

    const onRefreshHandler = () => {
        getFiles()
    }
    return (
        <>
            <Space direction='vertical' size={18}>
                <Row justify='space-between'>
                    <Space size={5}>
                        <Button icon={<BiUpload size={18} />} className='icon-button' disabled={isOracleInvoiced || sentForOracleInvoicing}
                            onClick={() => setIsOpen(true)} hidden={!(isAccessible([UserEnum.MANAGER, UserEnum.MANIFESTER, UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,]) || hasManifestationBtnAccess)}> Upload Manifest Supported Files</Button>
                        <Button icon={<BiRefresh size={18} />} className='icon-button'
                            onClick={onRefreshHandler} hidden={!(isAccessible([UserEnum.MANAGER, UserEnum.MANIFESTER, UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,]) || hasManifestationBtnAccess)}></Button>
                    </Space>
                </Row>
                <Space wrap direction='vertical' size={[20, 20]} hidden={!(isAccessible([UserEnum.MANAGER, UserEnum.MANIFESTER, UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,]) || hasManifestationBtnAccess)}>
                    <ImageRenderComponent list={manifestFiles} label={"Manifest Files"} />
                </Space>
            </Space >
            {isOpen ? <FileComponent open={isOpen} onClose={(prev) => setIsOpen(prev)} /> : null}
        </>
    )
}

export default FileUploadComponent